import { FieldType, ViewModelBase } from "@shoothill/core";
import { action, computed, observable, reaction, runInAction } from "mobx";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import moment from "moment";
import { AppUrls } from "AppUrls";
import { StoresInstance } from "Globals/Stores";

// View models
import FormSectionViewModelBase from "Globals/ViewModels/FormSections/FormSectionViewModelBase";

// Models
import { FormSectionsEnum } from "Globals/Models/FormSectionsEnum";
import { UserFile } from "Globals/Models/UserFile";
import SupportingInformationViewModel from "./SupportingInformationViewModel";
import { ParentSupportingInformationModel } from "Globals/Models/Domain/FormSections/SupportingInformation/ParentSupportingInformationModel";

export default class ParentSupportingInformationViewModel extends FormSectionViewModelBase<ParentSupportingInformationModel> {
    @observable public supportingInformationViewModels: SupportingInformationViewModel[] = [];
    constructor(parentSupportingInformationModel: ParentSupportingInformationModel, _updateSectionCompleted: (index: FormSectionsEnum, value: boolean) => void) {
        super(_updateSectionCompleted, parentSupportingInformationModel);
        this.createViewModels();
        if (this.updateSectionCompleted) {
            this.updateSectionCompleted(FormSectionsEnum.SupportingInformation, this.canProceed);
        }
        (window as any).psivm = this;
    }

    public getEditableCopyByRouteAndPlaceholderNumber = (route: string, placeholderNumber: number) => {
        let editableCopyRoute = StoresInstance.Domain.editableCopyRoutes.find((r) => r.route === route);

        if (editableCopyRoute !== undefined) {
            let editableCopyRouteId: string = editableCopyRoute.id;
            return StoresInstance.Domain.editableCopies.find((c) => c.routeId === editableCopyRouteId && c.placeholderNumber === placeholderNumber)?.copyValue as string;
        }

        return "";
    };

    @action
    private createViewModels(): void {
        if (this.model.supportingInformationModels) {
            for (const model of this.model.supportingInformationModels) {
                this.supportingInformationViewModels.push(new SupportingInformationViewModel(this, model));
            }
        }
    }

    @computed
    public get getSorted(): SupportingInformationViewModel[] {
        return this.supportingInformationViewModels
            .slice()
            .filter((a) => !a.model.isDeleted)
            .sort((a, b) => (b.model.createdDate ? new Date(b.model.createdDate).getTime() : 0) - (a.model.createdDate ? new Date(a.model.createdDate).getTime() : 0));
    }

    @computed
    public get getUserFiles(): UserFile[] {
        let userFiles: UserFile[] = [];
        this.getSorted.forEach((a) => {
            userFiles.push({
                id: a.model.id,
                documentTypeId: a.model.documentTypeId,
                fileName: a.model.fileName,
                fileUrl: a.model.documentUrl,
            });
        });
        return userFiles;
    }

    @action
    public handleDocTypeChange = (index: number, val: string) => {
        let fileToChange = this.getSorted[index];
        fileToChange.setValue("documentTypeId", val);
    };

    @action
    public handleInputChange = (): void => {
        this.updateSectionCompleted(FormSectionsEnum.SupportingInformation, this.canProceed);
    };

    @computed
    public get canProceed(): boolean {
        let completed = true;
        // SW #11550
        // if (this.supportingInformationViewModels.length < 1) {
        //     completed = false;
        // }
        return completed;
    }

    public async isFieldValid(fieldName: keyof FieldType<ParentSupportingInformationModel>, value: any): Promise<boolean> {
        return await this.isValid(fieldName, value);
    }

    public async isValid(fieldName: keyof FieldType<ParentSupportingInformationModel>, value: any, isRequired: boolean = false): Promise<boolean> {
        // let { isValid, errorMessage } = await this.validateDecorators(fieldName);
        // if (fieldName === "reportsRequired") {
        //     if (value === true) {
        //         if (this.supportingInformationViewModels.length < 1) {
        //             errorMessage = "required to proceed";
        //             isValid = false;
        //         }
        //     }
        // }
        // if ((fieldName as any) === "supportingInformationModels") {
        //     let supportingValidation = true;
        //     for (const supportingInformationViewModel of this.supportingInformationViewModels) {
        //         const valid = await supportingInformationViewModel.isModelValid();
        //         if (!valid) {
        //             supportingValidation = false;
        //         }
        //     }
        //     if (!supportingValidation) {
        //         errorMessage = "required to proceed";
        //         isValid = false;
        //     }
        // }
        // if (!isValid) {
        //     console.log("Field Not valid: ", fieldName);
        // }
        // this.setError(fieldName, errorMessage);
        // this.setValid(fieldName, isValid);
        // return isValid;
        // #11549 - Ensure application can be submitted without providing Supporting Documents.
        return true;
    }

    /**
     * @returns boolean does this section have any errors
     */
    @action
    public async showUnfinishedFields(): Promise<boolean> {
        let hasError = false;
        for (const _field of Object.keys(this.model)) {
            let field = _field as keyof FieldType<ParentSupportingInformationModel>;
            let value = this.model.getValue(field);
            let isRequired = true;
            let isValid = await this.isValid(field, value, isRequired);
            if (isValid == false) {
                hasError = true;
            }
        }
        console.log("showUnfinishedFields: " + hasError);
        return hasError;
    }
    public beforeUpdate: undefined;
}
